type PropsT = {
  digit: string;
  className: string;
  sec_line: string;
  telephonySendDigits: (digit: string) => void;
};

const Dialer = ({
  digit,
  sec_line,
  className,
  telephonySendDigits,
}: PropsT) => {
  return (
    <button
      className={className}
      onClick={() => {
        telephonySendDigits(digit);
      }}
    >
      <span className="digit">{digit}</span>
      <span className="sec_line">{sec_line}</span>
    </button>
  );
};

export default Dialer;
